import React from 'react'
let vector = ['1'];
let total = 0,price = 0, total_d = 0;
let validate_count = 1;
let data_img = '';

const Info = function info ({product,images,versions,version_first,formProduct,onChangeProduct,onChangeVersion,plusMore,plusLess,clickAddCart,clickAddNotCart,product_category,product_brand,product_line}){
    return (
        <main>
            <div className="back flex w90">
                <a href={https+"shop"} className="flex">
                    <img src={https+"img/back.svg"} alt="⬅"/>
                    <span>Atrás</span>
                </a>
            </div>
        
            <section className="product">
                <h2>{product.name}</h2>
                <div className="container colflex w90 ">
                    <div className="galleryProduct">
                        {vector.map((v) => {
                            if (images.length > 0 || versions.length > 0 ) {
                            if (validate_count == 1) {
                                validate_count = 2;
                                setTimeout(function (){
                                    $('#galleryProduct').slick({
                                        dots: false,
                                        arrows: false,
                                        asNavFor: '#asNavProduct',
                                        fade: true,
                                        responsive: [
                                        {
                                            breakpoint: 768,
                                            settings: {
                                            dots: true,
                                            fade: false
                                            }
                                        }
                                        ]
                                    });
                                    
                                    $('#asNavProduct').slick({
                                        slidesToShow: 4,
                                        slidesToScroll: 1,
                                        asNavFor: '#galleryProduct',
                                        dots: false,
                                        arrows: false,
                                        centerMode: true,
                                        focusOnSelect: true,
                                        swipe: false,
                                        responsive: [
                                        {
                                            breakpoint: 1600,
                                            settings: {
                                            slidesToShow: 3,
                                            }
                                        },
                                        {
                                            breakpoint: 769,
                                            settings: {
                                            slidesToShow: 2,
                                            }
                                        },
                                        ]
                                    });
                                },2000);
                            }
                            }
                        })}
                        <div className="slider w90" id="galleryProduct">
                            <div className='img'>
                                <div>
                                    <img src={https+product.img} alt="item"/>
                                </div>
                            </div>
                            {images.map((i)=>
                                {
                                    data_img = i.img;
                                    data_img = data_img.replace('https://admin.monstercaraudio.com.co/','');
                                    data_img = data_img.replace('https://monstercaraudio.com.co/','');
                                    data_img = data_img.replace('http://127.0.0.1:8000/','');
                                    return <div className='img' key={i.id}>
                                        <div>
                                            <img 
                                                src={https+data_img} 
                                                alt="item"
                                            />
                                        </div>
                                    </div>
                                }
                            )}
                            {versions.map((v)=>
                                {
                                    if(v.img != null && v.img != ""){
                                        data_img = v.img;
                                        data_img = data_img.replace('https://admin.monstercaraudio.com.co/','');
                                        data_img = data_img.replace('https://monstercaraudio.com.co/','');
                                        data_img = data_img.replace('http://127.0.0.1:8000/','');
                                        return <div className='img' key={v.id}>
                                            <div>
                                                <img 
                                                    src={https+data_img} 
                                                    alt="item"
                                                />
                                            </div>
                                        </div>  
                                    }
                                }
                            )}
                        </div>
                        <div className="tron dnone">
                            <div className="asNav" id="asNavProduct">
                            <div className='img'>
                                <div>
                                    <img src={https+product.img} alt="item"/>
                                </div>
                            </div>
                            {images.map((i)=>
                                {
                                    data_img = i.img;
                                    data_img = data_img.replace('https://admin.monstercaraudio.com.co/','');
                                    data_img = data_img.replace('https://monstercaraudio.com.co/','');
                                    data_img = data_img.replace('http://127.0.0.1:8000/','');
                                    return <div className='img' key={i.id}>
                                        <div>
                                            <img src={https+data_img} alt="item"/>
                                        </div>
                                    </div>
                                }
                            )}
                            {versions.map((v)=>
                                {
                                    if(v.img != null && v.img != ""){
                                        data_img = v.img;
                                        data_img = data_img.replace('https://admin.monstercaraudio.com.co/','');
                                        data_img = data_img.replace('https://monstercaraudio.com.co/','');
                                        data_img = data_img.replace('http://127.0.0.1:8000/','');
                                        return <div className='img' key={v.id}>
                                            <div>
                                                <img src={https+data_img} alt="item"/>
                                            </div>
                                        </div>
                                    }
                                }
                            )}
                            </div>
                        </div>
                    </div>
                    <div className="infoProduct colflex w90">
                    <div className="priceProduct colfex">
                        {vector.map((v)=>
                            {
                                if (versions.length > 0) {
                                    if(version_first.descount > 0){
                                        total = new Intl.NumberFormat().format(version_first.price);
                                        total = total.replace(/,/g , ".");
                                        price = (version_first.price - (version_first.price * version_first.descount / 100));
                                        total_d = new Intl.NumberFormat().format(price);
                                        total_d = total_d.replace(/,/g , ".");
                                        return (
                                            <div key={1}>
                                                <span>${total}</span>
                                                <div className="flex">
                                                    <h4>${total_d}</h4>
                                                    <h5>{version_first.descount}% OFF</h5>
                                                </div>
                                            </div>
                                        )
                                    }else{
                                        total = new Intl.NumberFormat().format(version_first.price);
                                        total = total.replace(/,/g , ".");
                                        return (
                                            <div key={1}>
                                                <span></span>
                                                <div className="flex">
                                                    <h4>${total}</h4>
                                                    <h5></h5>
                                                </div>
                                            </div>
                                        )
                                    } 
                                }else{
                                    if(product.descount > 0){
                                        total = new Intl.NumberFormat().format(product.price);
                                        total = total.replace(/,/g , ".");
                                        price = (product.price - (product.price * product.descount / 100));
                                        total_d = new Intl.NumberFormat().format(price);
                                        total_d = total_d.replace(/,/g , ".");
                                        return (
                                            <div key={1}>
                                                <span>${total}</span>
                                                <div className="flex">
                                                    <h4>${total_d}</h4>
                                                    <h5>{product.descount}% OFF</h5>
                                                </div>
                                            </div>
                                        )
                                    }else{
                                        total = new Intl.NumberFormat().format(product.price);
                                        total = total.replace(/,/g , ".");
                                        return (
                                            <div key={1}>
                                                <span></span>
                                                <div className="flex">
                                                    <h4>${total}</h4>
                                                    <h5></h5>
                                                </div>
                                            </div>
                                        )
                                    }  
                                }
                            }
                        )}
                        <div className="modalVideo">
                            <a target="_blank" href={product.link_video} data-fancybox>Ver video</a>
                            <img src={https+"img/video.png"} alt="video"/>
                        </div>
                        <div className="modalVideo">
                            <a target="_blank" href={product.link_pdf} data-fancybox>Ver Ficha Tecnica</a>
                            <img src={https+"img/video.png"} alt="video"/>
                        </div>
                    </div>
                
                    <div className="descriptionProduct colflex">
                        <h2 className="dnone">{product.name}</h2>
                        <strong>Categoria:</strong> {product_category.name}
                        <strong>Marca:</strong> {product_brand.name}
                        <strong>Linea:</strong> {product_line.name} <br/>
                        <span>Descripción</span>
                        
                        {vector.map((v)=>
                            {
                                if (versions.length > 0) {
                                    return <p key={1}>{version_first.description}</p>
                                }else{
                                    return <p key={1}>{product.description}</p>
                                }
                            }
                        )}
                    </div>
                    <div className="detailProduct flex w90">
                        <input 
                            type="hidden" 
                            name="product_id"
                            value={formProduct.product_id}
                            onChange={onChangeProduct}
                        /> 
                        {vector.map((v) => {
                                if (versions.length > 0) {
                                    return <input key={1}
                                        type="hidden" 
                                        name="version_go" 
                                        value="si"
                                    /> 
                                }else{
                                    return <input key={1}
                                        type="hidden" 
                                        name="version_go" 
                                        value="no"
                                    />  
                                }
                            }
                        )}
                        {vector.map((v) => {
                                if (versions.length > 0) {
                                    return (
                                        <select key={1}
                                        name="version_id"
                                        value={formProduct.version_id}
                                        onChange={onChangeVersion}
                                        >
                                            {versions.map((v)=>
                                                {
                                                    return <option key={v.id} value={v.id}>{v.name}</option>
                                                }
                                            )}
                                        </select>
                                    )
                                }
                            }
                        )}
                        <div className="colflex">
                            <div className="flex">
                                <img className="minus" src={https+"img/minus.svg"} alt="-" onClick={plusLess}/>
                                <span>{formProduct.cant}</span>
                                <img className="plus" src={https+"img/plus.svg"} alt="+" onClick={plusMore}/>
                            </div>
                        </div>
                    </div>
                    <div className="ctaShop colflex">
                        <a className="buyNow" onClick={clickAddCart}>Comprar ahora</a>
                        <a className="addCart flex" onClick={clickAddNotCart}>
                            Agregar
                            <img src={https+"img/menuMob/cart.svg"} alt="🛒"/>
                        </a>
                    </div>
                </div>
                </div>
            </section>
        </main>
)
}

export default Info
